import { useStaticQuery, graphql } from 'gatsby'
import { getActiveItems } from '../../dataManipulation/cmsItems'

export const usePromotionsApiData = () => {
  const data = graphql`
    {
      promotionsApi {
        values {
          promotions {
            slug
            image {
              alt
              height
              width
              url
              sizes {
                medium
                medium_large
                large
                thumbnail
              }
            }
            activeFrom
            activeTo
            title
            type
            sub_type
            promotion_identifier
          }
          lang
        }
      }
    }
  `
  const response = useStaticQuery(data)

  const {
    promotionsApi: { values: promotionsData },
  } = response

  const promos = getActiveItems(promotionsData?.[0]?.promotions) || []

  const getOrderedPromotionTypes = () => {
    const promotionsInCorrectOrder = [
      'sports',
      'casino',
      'livecasino',
      'welcome_offer',
      'virtualsports',
    ]
    const usedPromotionTypes = []
    const toReturn = []

    promos.forEach((promo) => {
      if (!usedPromotionTypes.includes(promo.type))
        usedPromotionTypes.push(promo.type)
    })
    promotionsInCorrectOrder.forEach((promoType) => {
      if (usedPromotionTypes.includes(promoType)) toReturn.push(promoType)
    })
    return ['all', ...toReturn]
  }

  const promotionTypes = getOrderedPromotionTypes()

  return { promos, promotionTypes }
}
